<p-toast key="global-toast" [life]="3000" position="bottom-right"></p-toast>
<router-outlet></router-outlet>
